const statusCodes = {
    UnAuthorizedStatusCode: 401,
    InternalErrorCode: 500,
    ValidationErrors: 400,
    SpecialErrors: [409, 404, 403, 422]
}

export const getAuthBearerTokenString = token => `Bearer ${token}`

export const getAuthBasicValue = (username, password) => `Basic ${btoa(username + ':' + password)}`

export default statusCodes
